import { JsonRpcSigner, Signer } from 'ethers';

import config from '#/config';
import { getCurrentStateChainConfig } from '#/config/configUtils';
import {
  KatanaExchange_v2__factory,
  FixedIncomeVaultProvider_v1__factory,
  FixedIncomeVaultProviderStateAggregator_v1,
  FixedIncomeVaultProviderStateAggregator_v1__factory,
} from '#/lib/ethereum/contracts/contractsFromSdk';
import { getSigner } from '#/lib/ethereum/wallets';
import { triggerWalletChainSwitchIfPossible } from '#/lib/ethereum/wallets/switchEthereumChain';
import { getAnonymousRPCProvider } from '#/lib/ethereum/wallets/utils';
import { IWallet } from '#/reduxState/wallet/walletReducer';

/** https://github.com/berachain/contracts/blob/main/src/pol/rewards/RewardVault.sol#L318 */
export function getVaultProviderContract(signer?: Signer | JsonRpcSigner) {
  return FixedIncomeVaultProvider_v1__factory.connect(
    config.chains.katanaChain.fixedIncomeVaultProviderAddress,
    signer ?? getAnonymousRPCProvider()
  );
}

export function getVaultAggregatorContract() {
  return FixedIncomeVaultProviderStateAggregator_v1__factory.connect(
    config.chains.katanaChain.fixedIncomeVaultProviderStateAggregatorAddress,
    getAnonymousRPCProvider()
  );
}

export function getExchangeContract() {
  return KatanaExchange_v2__factory.connect(
    config.chains.katanaChain.exchangeContract,
    // @ts-expect-error TS6 ethers dual-package types (lib.esm vs lib.commonjs)
    getAnonymousRPCProvider()
  );
}

/** Derived from SDK's loadVaultDepositorsByManagerWallet return type */
export type LoadVaultDepositorsResultStructOutput = Pick<
  FixedIncomeVaultProviderStateAggregator_v1.LoadVaultDepositorsResultStructOutput,
  // TODO: vaults use this
  // Awaited<
  //   ReturnType<
  //     FixedIncomeVaultProviderStateAggregator_v1['loadVaultDepositorsByManagerWallet']
  //   >
  // >[number],
  'owedQuantity' | 'initialDepositTimestampInS' | 'costBasis'
>;

/** Derived from SDK's loadVaultWithdrawalQueue return type */
// export type VaultWithdrawQueueItemStructOutput = Awaited<
//   ReturnType<FixedIncomeVaultProviderStateAggregator_v1['loadVaultWithdrawalQueue']>
// >[number];

export const getKatanaWalletSigner = async (wallet: IWallet) => {
  const chainConfig = getCurrentStateChainConfig('katanaChain');
  await triggerWalletChainSwitchIfPossible(
    wallet.walletType,
    chainConfig,
    await getSigner(wallet, undefined, false)
  );
  return await getSigner(wallet);
};
